import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const TextSkeleton = ({ maxLines = 3, className, lineClassName }) => {
  return (
    <div
      className={cn('text-skeleton', className)}
      aria-hidden="true"
      role="presentation"
    >
      {Array.from({ length: maxLines }).map((_, i) => (
        <div key={i} className={cn('text-skeleton__line', lineClassName)} />
      ))}
    </div>
  );
};

TextSkeleton.propTypes = {
  maxLines: PropTypes.number,
  className: PropTypes.string,
  lineClassName: PropTypes.string,
};

TextSkeleton.viewModelMeta = 'ignore';

export default TextSkeleton;
